const sliderElements = document.querySelectorAll('.announcement__slider-item');
const sliderElementsCount = sliderElements.length;
let currentSlide, slideIndex;

let prevButton = document.querySelector('.announcement-slider-buttons button[name="previous"]');
let nextButton = document.querySelector('.announcement-slider-buttons button[name="next"]');

function initialiseCarousel() {
  sliderElements.forEach(element => {
    element.classList.remove('active');
  });
  currentSlide = sliderElements[0];
  slideIndex = 0;
  currentSlide.classList.add('active');
}

initialiseCarousel();

function updateSlide() {
  currentSlide.classList.remove('active');
  currentSlide = sliderElements[slideIndex];
  currentSlide.classList.add('active');
}

function changeToNextSlide() {
  slideIndex = (slideIndex + 1) % sliderElementsCount;
  updateSlide();
}

function changeToPrevSlide() {
  slideIndex--;
  if (slideIndex < 0) {
    slideIndex += sliderElementsCount;
  }
  updateSlide();
}

prevButton.addEventListener('click', e => {
  changeToPrevSlide();
});

nextButton.addEventListener('click', e => {
  changeToNextSlide();
});

setInterval(changeToNextSlide, 5000);
